export default __webpack_public_path__ + "static/media/section3-bg4.25e72f85.png";